import { experienceApiClient } from '@/config/httpClients';
import type { ServiceProvider } from '../addressSearch/schemas';
import type { ServiceQualificationResponse } from './schemas';
import { ServiceQualificationResponseSchema } from './schemas';

const getServiceQualification = async ({
  serviceProviders,
}: {
  serviceProviders: {
    name: ServiceProvider;
    locationId: string;
  }[];
}) => {
  const queryString = serviceProviders
    .map(({ name, locationId }) => `${name.toLowerCase()}=${locationId}`)
    .join('&');

  const response = await experienceApiClient
    .get<ServiceQualificationResponse>(
      `v2/service-qualification?${queryString}&brand=exetel`
    )
    .json();
  if (!ServiceQualificationResponseSchema.safeParse(response).success) {
    //TODO: Log error to Sentry
    console.log('Service qualification response validation error');
  }
  return response;
};

export { getServiceQualification };
